export default class ProductOption {
    public processItemId = 0;
    public text = "";
    public processOptionId = 0;
    public processName = "";
}
